/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState } from 'react';
import Select from 'react-select';

interface ByMeByAllFilterProps {
  source: string;
  byMe: boolean;
  byAll: boolean;
  handle: () => void;
}

const ByMeByAllFilter = (props: ByMeByAllFilterProps) => {
  const { source, byMe, byAll, handle } = props;
  const [byMeEnabled, setByMeEnabled] = useState<boolean>(byMe);
  const [byAllEnabled, setByAllEnabled] = useState<boolean>(byAll);

  const handleButton = () => {
    setByMeEnabled(!byMeEnabled);
    setByAllEnabled(!byAllEnabled);
    handle();
  };

  const options = [
    { value: 'me', label: 'Por mim' },
    { value: 'all', label: 'Por todos' },
  ];

  const selectedOption = byMeEnabled ? options[0] : options[1];

  const handleSelectChange = (selected: any) => {
    if (!selected) return;

    if (selected.value === 'me' && !byMeEnabled) handleButton();
    if (selected.value === 'all' && !byAllEnabled) handleButton();
  };

  return (
    <>
      {source === 'chat' ? (
        <div className="w-75">
          <Select
            name="ByMeOrAllSelect"
            closeMenuOnSelect
            isClearable={false}
            value={selectedOption}
            options={options}
            onChange={handleSelectChange}
          />
        </div>
      ) : (
        <>
          <button
            className={`mr-1 btn ${byMeEnabled ? 'btn-primary' : 'btn-outline-primary'}`}
            type="button"
            onClick={() => {
              if (byMeEnabled) return;
              handleButton();
            }}
          >
            Por mim
          </button>
          <button
            className={`ml-1 btn ${byAllEnabled ? 'btn-primary' : 'btn-outline-primary'}`}
            type="button"
            onClick={() => {
              if (byAllEnabled) return;
              handleButton();
            }}
          >
            Por todos
          </button>
        </>
      )}
    </>
  );
};

export default ByMeByAllFilter;
